import { GetCreditorAccountSummaryRequest } from '../types/GetCreditorAccountSummaryRequest';
import RestApiClient from '../../../../core/api/RestApiClient';
import { CreditorAccountSummary } from '../types/CreditorAccountSummary';

export default {
  getCreditorAccountSummary: async(request: GetCreditorAccountSummaryRequest): Promise<CreditorAccountSummary> => {
    return await RestApiClient.post("modules/CreditorAccountSummaryModule/creditorAccountSummary", request);
  }
}